import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import DataSourceCard from './DataSourceCard'
import { useDataSourceCatalogLookup } from './useDataSourceCatalogLookup'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    marginTop: 'var(--margin-lg)',
    justifyContent: 'center',
    padding: '0 var(--padding-md)'
  }
}))

function DataSourcesSummary ({ toolCallSummary }) {
  const classes = useStyles()
  const { getCatalogDatasource } = useDataSourceCatalogLookup()

  if (!toolCallSummary?.dataSources?.length) {
    return null
  }

  return (
    <div className={classes.container}>
      {toolCallSummary.dataSources.map((source, idx) => {
        const catalogDatasource = getCatalogDatasource(source.type, source.name)
        // Use stable key based on source identity to prevent animation restart on re-renders
        const stableKey = `${source.type}-${source.name}`
        return (
          <FadeIn key={stableKey} duration={0.3} delay={idx * 0.05}>
            <DataSourceCard
              catalogDatasource={catalogDatasource}
              name={source.name}
              type={source.type}
              count={source.count}
            />
          </FadeIn>
        )
      })}
    </div>
  )
}

DataSourcesSummary.propTypes = {
  toolCallSummary: PropTypes.shape({
    dataSources: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.oneOf(['view', 'api']).isRequired,
      name: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired
    })),
    totalSources: PropTypes.number,
    totalAccesses: PropTypes.number,
    toolCallCount: PropTypes.number
  })
}

export default DataSourcesSummary
